export const FETCH_USER = 'FETCH_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const ADD_GIFT_CONSULTATION_USER = 'ADD_GIFT_CONSULTATION_USER';
export const ADD_GIFT_NUTRITION_CONSULTATION_USER = 'ADD_GIFT_NUTRITION_CONSULTATION_USER';
export const DELETE_CONSULTATION_USER = 'DELETE_CONSULTATION_USER';
export const DELETE_NUTRITION_CONSULTATION_USER = 'DELETE_NUTRITION_CONSULTATION_USER';
